const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  loadingCount: state => state.app.loadingCount,
  loadingDelayed: state => state.app.loadingDelayed,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  userInfo: state => state.user.userInfo,
  tenantId: state => Number(state.user.userInfo?.tenantId || 0),
  organizationId: state => Number(state.user.userInfo?.organizationId || 0),
  tenantNum: state => state.user.userInfo?.tenantNum,
  roleId: state => state.user.userInfo?.currentRoleId,
  userId: state => state.user.userInfo?.id,
  cusId: state => state.user.userInfo?.cusId,
  isSiteRole: state => state.user.userInfo?.currentRoleLevel === 'site',
  level: state => state.user.userInfo?.currentRoleLevel,
  deptAbbr: state => state.user.userInfo?.deptAbbr,
  customerList: state => state.user.customerList,
  clientCodeList: state => state.user.clientCodeList,
  customerActivityList: state => state.user.customerActivityList,
  clientCodeActivityList: state => state.user.clientCodeActivityList,
  userGroup: state => state.user.userGroup,

  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  isSuperAdmin: state => state.user.isSuperAdmin,
  userPermissions: state => state.user.permissions,
  userPermissionBtns: state => state.user.permissionBtns,
  forecaseData: state => state.business.purchasForecast,
  storePriceControl: state => state.business.storePriceControl,
};
export default getters;
